/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.0 orion_supervisorSkin.glb -T 
Files: orion_supervisorSkin.glb [20.93MB] > C:\Users\eduardo.vieira\frontendOrion\public\models\orion_supervisorSkin-transformed.glb [739.26KB] (96%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function SupervisorSkin(pos) {
  const { nodes, materials } = useGLTF('/models/orion_supervisorSkin-transformed.glb')
  return (
    <group position={pos} dispose={null} rotation={[Math.PI/2,0,0]}>
      <mesh geometry={nodes.ImageToStlcom_orion_supervisor.geometry} material={materials['Material.001']} />
    </group>
  )
}

useGLTF.preload('/models/orion_supervisorSkin-transformed.glb')
